import React from 'react';

function Tooltip(props) {
	const { x, y, width, label, color } = props
	const h = 20
	return (
		<g
			className={`TimelineTooltip`}
			transform={`translate(${x} ${y})`}
		>
			<path
				fill={color}
				d={`M0,0 L${h/2},${h/2} l${width-h/2},0 l0,${-h} l${-(width-h/2)},0 z`}
			/>
			<text dx={h/2 + 2} dy='.37em'>{label}</text>
		</g>
	)
}

export default Tooltip


// WEBPACK FOOTER //
// ./src/Tooltip.js